/**
 * RQC — Requisição de Compras do escritório (ADR-0074).
 *
 * O formulário mora em Solicitações, mas o que ele cria é uma Requisição de
 * Compra comum (origem RQC) no quadro do comprador. Permissão própria:
 * `solicitacao_rqc:view|create` — o global `solicitacao:*` não libera.
 */

const PREF = "/api/rqc";

export const PERM_RQC_VER = "solicitacao_rqc:view";
export const PERM_RQC_CRIAR = "solicitacao_rqc:create";

/** Meus RQCs: onde cada pedido caiu e em que etapa está. */
export function listarMeusRqc(request) {
  return request(PREF);
}

/** Prioridades, motivos, categorias, unidades e o limite de anexos. */
export function opcoesRqc(request) {
  return request(`${PREF}/opcoes`);
}

/** Catálogo ativo da unidade — quem pede papel não tem `estoque:view`. */
export function buscarProdutosRqc(request, busca = "") {
  const q = new URLSearchParams();
  if (busca) q.set("busca", busca);
  return request(`${PREF}/produtos${q.toString() ? `?${q}` : ""}`, { silentError: true });
}

/**
 * Envia o RQC. `dados` = {prioridade, motivo_urgencia, data_necessaria,
 * motivo, justificativa, itens:[...]}; `anexos` = File[] (até 5).
 * O erro de validação volta em `payload.detalhe` — a tela mostra inline.
 */
export function enviarRqc(request, dados, anexos = []) {
  const formData = new FormData();
  formData.append("dados", JSON.stringify(dados));
  anexos.forEach((arquivo) => formData.append("anexos", arquivo));
  return request(PREF, {
    method: "POST",
    body: formData,
    headers: {}, // sem Content-Type: o browser define o boundary
    silentError: true,
  });
}

// ------------------------------------------------ junção (comprador)

const PREF_R = "/api/requisicoes";

/** O que a junção faria — não grava. Alimenta a confirmação. */
export function previaConsolidacao(request, principalId, incorporarIds) {
  return request(`${PREF_R}/${principalId}/consolidar/previa`, {
    method: "POST",
    body: JSON.stringify({ incorporar: incorporarIds }),
    silentError: true,
  });
}

export function consolidarRequisicoes(request, principalId, incorporarIds) {
  return request(`${PREF_R}/${principalId}/consolidar`, {
    method: "POST",
    body: JSON.stringify({ incorporar: incorporarIds }),
    silentError: true,
  });
}

/** "João", "João +2" — o card do quadro não cabe mais que isso. */
export function resumoSolicitantes(nomes = []) {
  if (!nomes.length) return "";
  return nomes.length === 1 ? nomes[0] : `${nomes[0]} +${nomes.length - 1}`;
}
